/// <reference path="../typings/index.d.ts" />
"use strict";
var BridgeDb_1 = require("./BridgeDb");
exports.BridgeDb = BridgeDb_1.BridgeDb;
var DataSourceSelect_1 = require("./components/DataSourceSelect");
exports.DataSourceSelect = DataSourceSelect_1.DataSourceSelect;
var EntityTypeSelect_1 = require("./components/EntityTypeSelect");
exports.BioPAXEntityTypeSelect = EntityTypeSelect_1.BioPAXEntityTypeSelect;
exports.WPEntityTypeSelect = EntityTypeSelect_1.WPEntityTypeSelect;
var Xref_1 = require("./components/Xref");
exports.Xref = Xref_1.Xref;
var XrefsAnnotationPanel_1 = require("./components/XrefsAnnotationPanel");
exports.XrefsAnnotationPanel = XrefsAnnotationPanel_1.XrefsAnnotationPanel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsOENBQThDOztBQUU5Qyx1Q0FBb0M7QUFBNUIsOEJBQUEsUUFBUSxDQUFBO0FBQ2hCLGtFQUErRDtBQUF2RCw4Q0FBQSxnQkFBZ0IsQ0FBQTtBQUN4QixrRUFBeUY7QUFBakYsb0RBQUEsc0JBQXNCLENBQUE7QUFBRSxnREFBQSxrQkFBa0IsQ0FBQTtBQUNsRCwwQ0FBdUM7QUFBL0Isc0JBQUEsSUFBSSxDQUFBO0FBQ1osMEVBQXVFO0FBQS9ELHNEQUFBLG9CQUFvQixDQUFBIn0=


//////////////////
// WEBPACK FOOTER
// ./~/bridgedb/lib/index.js
// module id = 246
// module chunks = 0